module.exports = __webpack_public_path__ + "img/图片6.e3c57613.png";